
export class RegexPatternHelper {
  public static isValidPattern = (text: string, pattern: string): boolean => {
    const reg = new RegExp(pattern);
    return reg.test(text);
  }
}
